import { Component } from '@angular/core';
import { SettingsPageService } from '../../services/SettingsPage.service';

@Component({
  selector: 'settings-menu',
  templateUrl: './settings-menu.component.html',
  styleUrls: ['./settings-menu.component.css']
})
export class SettingsMenuComponent {
  
  selectedTabIndex: number = 0;
  
  constructor( private settingsService: SettingsPageService) {
  }
  
    ngOnInit() {
      this.selectedTabIndex = this.settingsService.getSelectedTab();
    }
  
    onTabChange(tab: any): void {
      this.selectedTabIndex = tab.index;
      this.settingsService.setSelectedTab(tab.index);
    }

}
